import { render, staticRenderFns } from "./IndicatorRiskInterpreter.vue?vue&type=template&id=0f154c8b"
import script from "./IndicatorRiskInterpreter.vue?vue&type=script&lang=js"
export * from "./IndicatorRiskInterpreter.vue?vue&type=script&lang=js"
import style0 from "./IndicatorRiskInterpreter.vue?vue&type=style&index=0&id=0f154c8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports